export default __webpack_public_path__ + "static/media/presentation.85d102b9.pptx";